import React, {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {useRouter} from 'next/router';
import AppFooter from './AppFooter';
import MobileBottomNavigation from './components/MobileBottomNavigation';

import {Layout} from 'antd';

function MobileAppSafeLayout({
                                 children
                             }) {
    const {Content} = Layout;
    const router = useRouter()
    const ThemeState = useSelector(state => state.Theme)
    const contentRef = useRef(null)

    useEffect(() => {
        if (typeof window !== "undefined") {
            contentRef.current.scrollTop = 0;
        }
    }, [router])

    return <Layout className={
        `layout mobile-layout ${ThemeState.theme}-theme`
    }>
        <Content ref={contentRef}>
            {children}
        </Content>

        <MobileBottomNavigation logoutOnly={true}/>

        <AppFooter disableFooter={true}/>
    </Layout>
}

export default MobileAppSafeLayout